































































import { Component, Mixins } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';

import bButton from 'bootstrap-vue/es/components/button/button';
import bNavText from 'bootstrap-vue/es/components/nav/nav-text';

import TopnavNav from './TopnavNav';

@Component({
  components: {
    FontAwesomeIcon,
    bButton,
    bNavText,
  },
})
export default class NavMegaMenu extends Mixins(TopnavNav) {
  public faCaretDown = faCaretDown;
}

